import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { navigationItems } from '../data/restaurantData';

const Navigation = ({ scrollToSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = (sectionId) => {
    scrollToSection(sectionId);
    setIsMenuOpen(false); // Close menu after navigation
  };

  return (
    <nav className="fixed top-0 w-full bg-black/90 backdrop-blur-md z-50 transition-all duration-500">
      <div className="max-w-7xl mx-auto px-8 py-6">
        <div className="flex justify-between items-center">
          {/* Left section: Restaurant name only */}
          <div 
            onClick={() => handleNavClick('home')}
            className="text-3xl font-light tracking-wider text-red-600 transform hover:scale-105 transition-transform duration-300 cursor-pointer"
          >
            NOU VALENTINO
          </div>

          {/* Right section: Navigation */}
          <div className="flex items-center space-x-4">
            {/* Desktop Navigation */}
            <div className="hidden md:flex space-x-12">
              {navigationItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-white/80 hover:text-red-600 font-light text-sm tracking-widest transition-all duration-300 hover:scale-110 relative group"
                >
                  {item.label}
                  <span className="absolute bottom-0 left-0 w-0 h-px bg-red-600 transition-all duration-300 group-hover:w-full"></span>
                </button>
              ))}
            </div>

            {/* Mobile Hamburger Menu Button */}
            <button
              onClick={toggleMenu}
              className="md:hidden p-2 text-white/80 hover:text-red-600 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-black rounded-md"
              aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
              aria-expanded={isMenuOpen}
            >
              {isMenuOpen ? (
                <X size={24} className="transform transition-transform duration-300" />
              ) : (
                <Menu size={24} className="transform transition-transform duration-300" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Dropdown Menu */}
        <div className={`
          md:hidden
          absolute top-full left-0 right-0
          bg-black/95 backdrop-blur-md
          border-t border-red-900/30
          transform transition-all duration-300 ease-in-out
          ${isMenuOpen 
            ? 'opacity-100 translate-y-0 visible' 
            : 'opacity-0 -translate-y-4 invisible'
          }
        `}>
          <div className="max-w-7xl mx-auto px-8 py-6">
            <div className="flex flex-col space-y-4">
              {navigationItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleNavClick(item.id)}
                  className="text-white/80 hover:text-red-600 font-light text-base tracking-widest transition-all duration-300 relative group text-left py-3 border-b border-gray-800/50 last:border-b-0"
                >
                  {item.label}
                  <span className="absolute bottom-2 left-0 w-0 h-px bg-red-600 transition-all duration-300 group-hover:w-full"></span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div 
          className="md:hidden fixed inset-0 bg-black/50 backdrop-blur-sm z-[-1]"
          onClick={toggleMenu}
          aria-hidden="true"
        />
      )}
    </nav>
  );
};

export default Navigation;